<template>
  <div class="app-wrapper">
    <div class="navTopCum"></div>
    <!-- flex:true, -->
    <div :class="{
      navTop: true,
      logoDetail: !(navLogo === 'home' && !showTop),
    }">
      <div class="logo">
        <img v-if="navLogo === 'home' && !showTop" class="logoHeader" src="../../assets/img/logo-header.png" alt="logo" />
        <img v-else class="logoHeader" src="../../assets/img/logotop.png" alt="logo" />
      </div>
      <div class="menu flex">
        <ul class="items flex">
          <li v-for="item in routerList" :key="item.url" :class="{
              curText: item.name === $route.name
            }" @click="toView(item)">
            <span>{{ item.meta.title }}</span>
          </li>
        </ul>
        <div class="language flex">
          <div class="item curText">
            <span>English </span>
          </div>
          <div class="item">
            <span>&nbsp;/&nbsp;Japanese</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container">
      <transition name="fade-transform" mode="out-in">
        <!-- <div class="routerView"> -->
        <!-- <keep-alive :max="10">
        </keep-alive>-->
        <!-- </div> -->
        <router-view :key="$route.fullPath" />
      </transition>
    </div>
    <div class="footer">
      <img :src="require(`@/assets/img/footer.png`)" alt="foot" />
      <!-- <div class="box">
        <div class="logo">
          <img src="../../assets/img/logo-header.png" alt />
        </div>
        <div class="msg">
          <p>AID UNITED INTERNATIONAL CO.,LIMITED</p>
          <p>ADDRESS：ROOM 520，NO1065，WUZHONG ROAD,SHANGHAI 201103</p>
          <p>TEL ：86 21 51192324</p>
          <p>FAX ：86 21 51192356</p>
          <p>EMAIL ：HANSONWZS@HOTMAIL.COM</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      showTop: false,
      navLogo: null,
      routerList: this.$router.options.routes[0].children,
    }
  },
  watch: {
    $route(val) {
      this.updateNav(val.name)
    },
  },
  mounted() {
    this.updateNav(this.$route.name)
    this.scrolling()
    window.addEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling() {
      let current =
        document.documentElement.scrollTop || document.body.scrollTop;
      let vh = 100;
      if (current >= vh) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
      console.log(this.showTop)
    },
    updateNav(name) {
      if (name !== 'Home') {
        this.navLogo = 'other'
      } else {
        this.navLogo = 'home'
      }
    },
    toView(item) {
      if (item.name !== this.$route.name) {
        this.$router.push({ path: item.path })
      }
      // item.name===$route.name
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="less" scoped>
.flex {
  display: flex;
}

.app-wrapper {
  min-width: 1438px;
}

.navTopCum {
  height: 80px;
}

.navTop {
  height: 80px;
  background-color: #fff;
  padding: 0 48px 0 32px;
  justify-content: flex-end;
  line-height: 80px;
  font-size: 20px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);

  .logo {
    position: absolute;
    left: 32px;
    top: 0
  }

  .curText {
    color: #1A7DF0;
  }

  .logoHeader {
    width: 148px;
  }

  img {
    height: auto;
  }

  .menu {

    li:hover,
    .item:hover {
      color: #1A7DF0;
    }

    li {
      padding: 0 25px;
      position: relative;
    }

    li::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: #1A7DF0;
      opacity: 0;
      transition: .2s opacity;
    }

    li.curText::before {
      opacity: 1;
    }

    .language {
      margin-left: 98px;
    }

    span {
      cursor: pointer;
      font-weight: 600;
    }
  }
}

.logoDetail {
  background: #f7f8fb;

  .logo {
    display: flex;
    align-items: center;
    top: 50%;
    transform: translateY(-50%);
  }
}

.footer {
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
  /**
  height: 348px;
  background: 50% 100% no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
**/
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo {
    width: 161px;
    margin-right: 54px;
  }

  .msg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 20px;
    font-weight: 500;
    color: #e8f6ff;
    line-height: 30px;
    letter-spacing: 2px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue